export default {
  setObject(item: string, data: object): void {
    sessionStorage.setItem(item, JSON.stringify(data))
  },
  getObject(item: string): object {
    const value = sessionStorage.getItem(item)
    if (typeof value === 'string') {
      return JSON.parse(value)
    } else {
      return {}
    }
  },
  getArray(item: string): object {
    const value = sessionStorage.getItem(item)
    if (typeof value === 'string') {
      return JSON.parse(value)
    } else {
      return []
    }
  },
  getString(item: string): string {
    const value = sessionStorage.getItem(item)
    return value || '*'
  },
  setString(item: string, data: string) {
    sessionStorage.setItem(item, data)
  },
  removeItem(item: string) {
    sessionStorage.removeItem(item)
  }
}
